import { render, staticRenderFns } from "./Case-Footer.vue?vue&type=template&id=416cb2b0"
import script from "./Case-Footer.vue?vue&type=script&lang=js"
export * from "./Case-Footer.vue?vue&type=script&lang=js"
import style0 from "./Case-Footer.vue?vue&type=style&index=0&id=416cb2b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports